<div class="form-row" [formGroup]="form">
    <div class="col-4">
        <label>{{ label }}</label>
    </div>
    <ng-container [ngSwitch]="type">
        <ng-container *ngSwitchCase="IrregularPeriodModeTypes.Day">
            <div class="col-3">
                <app-dc-input-numeric formControlName="rollDay"></app-dc-input-numeric>
            </div>
            <div class="col-5">
                <app-dc-select 
                    formControlName="irregularPeriod"
                    [closeOnSelect]="true"
                    [items]="irregularPeriods">
                </app-dc-select>
            </div>
        </ng-container>
        <ng-container *ngSwitchCase="IrregularPeriodModeTypes.Period">
            <div class="col-4">
                <app-dc-date-input formControlName="endFirstPeriod"></app-dc-date-input>
            </div>
            <div class="col-4">
                <app-dc-date-input formControlName="startLastPeriod"></app-dc-date-input>
            </div>
        </ng-container>
    </ng-container>
</div>
